/** @jsx jsx */
import { css, jsx } from '@emotion/core';
const CSS_VAR_CONTENTS_OPACITY = '--contents-opacity';
const containerStyles = css({
  position: 'relative'
});
export const Container = ({
  children
}) => jsx("div", {
  css: containerStyles
}, children);
const contentsContainerStyles = css({
  pointerEvents: 'none',
  opacity: `var(${CSS_VAR_CONTENTS_OPACITY})`
});
export const ContentsContainer = ({
  contentsOpacity,
  children
}) => jsx("div", {
  style: {
    [CSS_VAR_CONTENTS_OPACITY]: contentsOpacity
  },
  css: [contentsContainerStyles]
}, children);
const spinnerContainerStyles = css({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
export const SpinnerContainer = ({
  children
}) => jsx("div", {
  css: spinnerContainerStyles
}, children);